import { render, staticRenderFns } from "./PrintRegistrationFee.vue?vue&type=template&id=b8c85a06&scoped=true&"
import script from "./PrintRegistrationFee.vue?vue&type=script&lang=js&"
export * from "./PrintRegistrationFee.vue?vue&type=script&lang=js&"
import style0 from "./PrintRegistrationFee.vue?vue&type=style&index=0&id=b8c85a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c85a06",
  null
  
)

export default component.exports